import React from 'react';
import MobileScannerView from '../components/ui/Mobile-Scanner/MobileScannerView';

function MobileScanner() {
  return <MobileScannerView />;
}

export default MobileScanner; 